import { Component } from '@angular/core';

@Component({
    selector: 'ai-dialog-actions',
    standalone: true,
    templateUrl: './dialog-actions.component.html',
    imports: [],
})
export class DialogActions {}
